<template>
  <div>
    <div class="main-sidebar-container" :class="{ expanded: toggleMainSidebar }" v-click-outside="mobileToggleSidebar">
      <div class="sidebar">
        <div class="logo-section">
          <img v-if="toggleMainSidebar" src="@/assets/img/spark_logo_white.svg" alt="Spark Logo"
            class="img-fluid px-2" />
          <img v-else src="@/assets/img/S.svg" alt="Spark Logo Small" class="logo-img" />
        </div>

        <div class="nav-menu-wrapper">
          <ul class="nav-menu-list">

            <li class="nav-menu-item" :title="!(toggleMainSidebar) ? 'Dashboard' : null">
              <router-link to="/dashboard" class="nav-menu-link" active-class="active">
                <span class="menu-icon">
                  <svg width="25" height="25" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.82285 0.75H9.63535C10.2266 0.75 10.7084 1.23195 10.7084 1.82285V6.51035C10.7084 7.1015 10.2265 7.5834 9.63535 7.5834H1.82285C1.23195 7.5834 0.75 7.10155 0.75 6.51035V1.82285C0.75 1.23189 1.23189 0.75 1.82285 0.75Z"
                      stroke="currentColor" stroke-width="1.5" />
                    <path
                      d="M1.82285 11.1665H9.63535C10.2265 11.1665 10.7084 11.6484 10.7084 12.2395V23.1771C10.7084 23.768 10.2266 24.2499 9.63535 24.2499H1.82285C1.23189 24.2499 0.75 23.768 0.75 23.1771V12.2395C0.75 11.6483 1.23195 11.1665 1.82285 11.1665Z"
                      stroke="currentColor" stroke-width="1.5" />
                    <path
                      d="M15.3645 17.4165H23.177C23.768 17.4165 24.2499 17.8983 24.2499 18.4895V23.177C24.2499 23.768 23.768 24.2499 23.177 24.2499H15.3645C14.7733 24.2499 14.2915 23.768 14.2915 23.177V18.4895C14.2915 17.8984 14.7734 17.4165 15.3645 17.4165Z"
                      stroke="currentColor" stroke-width="1.5" />
                    <path
                      d="M22.427 0.75H23.177C23.768 0.75 24.2499 1.23189 24.2499 1.82285V12.7604C24.2499 13.3516 23.177 13.8334 23.177 13.8334H15.3645C14.7734 13.8334 14.2915 13.3515 14.2915 12.7604V1.82285C14.2915 1.23194 14.7733 0.75 15.3645 0.75H22.427Z"
                      stroke="currentColor" stroke-width="1.5" />
                  </svg>
                </span>
                <span class="menu-label">Dashboard</span>
              </router-link>
            </li>

            <!-- Platforms Delivery Dropdown parent menu -->
            <li class="nav-menu-item" :title="!(toggleMainSidebar) ? 'Platforms Delivery' : null">
              <div @click="togglePlatformsDeliveryMenu" class="nav-menu-link-container">
                <a href="#" @click.prevent class="nav-menu-link submenu-toggle"
                  :class="{ active: isPlatformsDeliveryActive, 'is-open': platformsDeliveryMenuOpen }">
                  <span class="menu-icon"><i class="fa-solid fa-truck-ramp-box fa-lg"></i></span>
                  <span class="menu-label">Platforms Delivery</span>
                  <span class="menu-beta-tag">BETA</span>
                </a>
                <span class="submenu-arrow" :class="{ rotated: platformsDeliveryMenuOpen }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </div>
              <transition name="submenu-slide">
                <ul class="submenu" v-show="platformsDeliveryMenuOpen">
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Regression Library' : null">
                    <router-link to="/regression-library" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-list-check"></i></span>
                      <span class="menu-label">Regression Library</span>
                      <span class="menu-beta-tag">BETA</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Quick Links' : null">
                    <router-link to="/quick-links" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-link"></i></span>
                      <span class="menu-label">Quick Links</span>
                      <span class="menu-beta-tag">BETA</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Platform Releases' : null">
                    <router-link to="/platform-releases" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-layer-group"></i></span>
                      <span class="menu-label">Platform Releases</span>
                      <span class="menu-beta-tag">BETA</span>
                    </router-link>
                  </li>
                </ul>
              </transition>
            </li>

            <li class="nav-menu-item" :title="!(toggleMainSidebar) ? 'Client Questions' : null">
              <router-link to="/client-questions" class="nav-menu-link" active-class="active">
                <span class="menu-icon">
                  <i class="fa fa-clipboard-question fa-lg"></i>
                </span>
                <span class="menu-label">Client Questions</span>
              </router-link>
            </li>

            <li class="nav-menu-item" v-if="$store.state.auth.isSuperAdmin"
              :title="!(toggleMainSidebar) ? 'Sales Pipeline' : null">
              <div @click="toggleLeadsMenu" class="nav-menu-link-container">
                <a href="#" @click.prevent class="nav-menu-link submenu-toggle"
                  :class="{ active: isLeadsActive, 'is-open': leadsMenuOpen }">
                  <span class="menu-icon"><i class="fa fa-users-line fa-lg"></i></span>
                  <span class="menu-label">Sales Pipeline</span>
                </a>
                <span class="submenu-arrow" :class="{ rotated: leadsMenuOpen }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </div>
              <transition name="submenu-slide">
                <ul class="submenu" v-show="leadsMenuOpen">
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Leads' : null">
                    <router-link to="/leads" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-users"></i></span>
                      <span class="menu-label">Leads</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Proposals' : null">
                    <router-link to="/proposals" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-file-contract"></i></span>
                      <span class="menu-label">Proposals</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Contracts' : null">
                    <router-link to="/contracts" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-file-signature"></i></span>
                      <span class="menu-label">Contracts</span>
                    </router-link>
                  </li>
                </ul>
              </transition>
            </li>

            <li class="nav-menu-item" v-if="$store.state.auth.isSuperAdmin"
              :title="!(toggleMainSidebar) ? 'Organisations' : null">
              <div @click="toggleClientsMenu" class="nav-menu-link-container">
                <a href="#" @click.prevent class="nav-menu-link submenu-toggle"
                  :class="{ active: isClientsActive, 'is-open': clientsMenuOpen }">
                  <span class="menu-icon"><i class="fa-solid fa-user-tie fa-lg"></i></span>
                  <span class="menu-label">Organisations</span>
                </a>
                <span class="submenu-arrow" :class="{ rotated: clientsMenuOpen }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </div>
              <transition name="submenu-slide">
                <ul class="submenu" v-show="clientsMenuOpen">
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'All Organisations' : null">
                    <router-link to="/clients/view-clients" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-address-book"></i></span>
                      <span class="menu-label">All Organisations</span>
                    </router-link>
                  </li>
                </ul>
              </transition>
            </li>

            <li class="nav-menu-item" v-if="$store.state.auth.isSuperAdmin && !$store.state.auth.isConsultant"
              :title="!(toggleMainSidebar) ? 'Content Library' : null">
              <div @click="toggleContentLibraryMenu" class="nav-menu-link-container">
                <a href="#" @click.prevent class="nav-menu-link submenu-toggle"
                  :class="{ active: isContentLibraryActive, 'is-open': contentLibraryMenuOpen }">
                  <span class="menu-icon"><i class="fa fa-folder fa-lg"></i></span>
                  <span class="menu-label">Content Library</span>
                </a>
                <span class="submenu-arrow" :class="{ rotated: contentLibraryMenuOpen }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </div>
              <transition name="submenu-slide">
                <ul class="submenu" v-show="contentLibraryMenuOpen">
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Content Blocks' : null">
                    <router-link to="/content-library/blocks" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-cube"></i></span>
                      <span class="menu-label">Content Blocks</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Testimonials' : null">
                    <router-link to="/content-library/testimonials" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-handshake"></i></span>
                      <span class="menu-label">Testimonials</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Contract Templates' : null">
                    <router-link to="/content-library/contract-templates" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-file-lines"></i></span>
                      <span class="menu-label">Contract Templates</span>
                    </router-link>
                  </li>
                </ul>
              </transition>
            </li>

            <li class="nav-menu-item" v-if="$store.state.auth.isSuperAdmin"
              :title="!(toggleMainSidebar) ? 'Platform Settings' : null">
              <div @click="togglePlatformSettingsMenu" class="nav-menu-link-container">
                <a href="#" @click.prevent class="nav-menu-link submenu-toggle"
                  :class="{ active: isPlatformSettingsActive, 'is-open': platformSettingsMenuOpen }">
                  <span class="menu-icon"><i class="fa fa-gears fa-lg"></i></span>
                  <span class="menu-label">Platform Settings</span>
                </a>
                <span class="submenu-arrow" :class="{ rotated: platformSettingsMenuOpen }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </div>
              <transition name="submenu-slide">
                <ul class="submenu" v-show="platformSettingsMenuOpen">
                  <li class="submenu-item" v-if="!$store.state.auth.isConsultant" :title="!(toggleMainSidebar) ? 'Vertex BDM Details' : null">
                    <router-link to="/bdm-details" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-person"></i></span>
                      <span class="menu-label">Vertex BDM Details</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" :title="!(toggleMainSidebar) ? 'Product Pricing' : null">
                    <router-link to="/product-pricing" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-tags"></i></span>
                      <span class="menu-label">Product Pricing</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" v-if="!$store.state.auth.isConsultant" :title="!(toggleMainSidebar) ? 'Dynamic Variables' : null">
                    <router-link to="/dynamic-variables" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-code"></i></span>
                      <span class="menu-label">Dynamic Variables</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" v-if="!$store.state.auth.isConsultant" :title="!(toggleMainSidebar) ? 'Contract Settings' : null">
                    <router-link to="/contract-settings" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-file-signature"></i></span>
                      <span class="menu-label">Contract Settings</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" v-if="!$store.state.auth.isConsultant" :title="!(toggleMainSidebar) ? 'Maintenance Settings' : null">
                    <router-link to="/maintenance-settings/dashboard" class="submenu-link" active-class="active">
                      <span class="menu-icon"><i class="fa-solid fa-wrench"></i></span>
                      <span class="menu-label">Maintenance Settings</span>
                    </router-link>
                  </li>
                </ul>
              </transition>
            </li>

            <li class="nav-menu-item" v-if="$store.state.auth.isSuperAdmin && !$store.state.auth.isConsultant && !$store.state.auth.isAdmin" :title="!(toggleMainSidebar) ? 'Job Settings' : null">
              <router-link to="/cron" class="nav-menu-link" active-class="active">
                <span class="menu-icon">
                  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.783 1.66L9 0L17.217 1.66C17.4391 1.70488 17.6377 1.81724 17.78 1.97855C17.9224 2.13986 18 2.34047 18 2.54727V11.6264C17.9999 12.5243 17.756 13.4083 17.2899 14.2C16.8238 14.9917 16.1499 15.6665 15.328 16.1645L9 20L2.672 16.1645C1.85027 15.6666 1.17646 14.9919 0.710348 14.2004C0.244236 13.4089 0.000236356 12.5251 0 11.6273V2.54727C3.90378e-05 2.34047 0.0776379 2.13986 0.21999 1.97855C0.362341 1.81724 0.560937 1.70488 0.783 1.66ZM2 3.27636V11.6264C2.00001 12.225 2.16257 12.8143 2.47326 13.3421C2.78395 13.8699 3.23315 14.3197 3.781 14.6518L9 17.8155L14.219 14.6518C14.7667 14.3198 15.2158 13.8701 15.5265 13.3425C15.8372 12.8149 15.9998 12.2257 16 11.6273V3.27636L9 1.86364L2 3.27636ZM10 8.18182H13L8 14.5455V10H5L10 3.63636V8.18182Z"
                      fill="currentColor" />
                  </svg>
                </span>
                <span class="menu-label">Job Settings</span>
              </router-link>
            </li>



            <!-- Tester Debugger (Placed outside as a standalone top-level option) -->
            <li class="nav-menu-item" v-if="isDebuggerEnabled && $store.state.auth.isSuperAdmin && !$store.state.auth.isConsultant && !$store.state.auth.isAdmin" :title="!(toggleMainSidebar) ? 'Tester Debugger' : null">
              <router-link to="/debugger" class="nav-menu-link" active-class="active">
                <span class="menu-icon"><i class="fa-solid fa-bug fa-lg"></i></span>
                <span class="menu-label">Tester Debugger</span>
              </router-link>
            </li>

            <!-- Platform Guide (Placed after Tester Debugger) -->
            <li class="nav-menu-item" :title="!(toggleMainSidebar) ? 'Platform Guide' : null">
              <router-link to="/platform-guide" class="nav-menu-link" active-class="active">
                <span class="menu-icon"><i class="fa-solid fa-book-open fa-lg"></i></span>
                <span class="menu-label">Platform Guide</span>
              </router-link>
            </li>

          </ul>
        </div>

        <!-- Organisation Switcher Row -->
        <div class="org-dropdown-container" v-if="organisationsList && organisationsList.length > 0">
          <div class="footer-divider"></div>
          <div class="account-menu-wrapper" @click.stop="toggleOrgDropdown">
            <div class="user-info">
              <div class="user-avatar-wrapper org-avatar-wrapper">
                <div class="user-avatar org-avatar">
                  {{ organisation.logo || 'V' }}
                </div>
              </div>
              <div class="user-details org-details">
                <div class="user-name org-name-text">
                  {{ truncateLongText(organisation.name, 18) || 'Vertex Cyber Security' }}
                </div>
                <div class="user-meta-row org-meta-row">
                  <span class="user-role-badge org-badge">Switch Organisation</span>
                </div>
              </div>
              <div class="footer-actions org-footer-actions">
                <span class="footer-chevron" :style="{ transform: `rotate(${orgChevronRotation}deg)` }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </div>
              <!-- Hover tooltip -->
              <div class="user-hover-tooltip org-hover-tooltip">
                <div class="tooltip-name">{{ organisation.name }}</div>
                <div class="tooltip-role"><i class="fa-solid fa-building"></i> Switch Organisation</div>
              </div>
            </div>
          </div>
          <!-- Organisation Dropdown list -->
          <transition name="dropdown-slide">
            <div class="user-dropdown org-dropdown-list" v-if="orgDropdownOpen">
              <div class="org-search-box p-2" v-if="organisationsList && organisationsList.length > 5">
                <input v-model="search" type="text" class="form-control form-control-sm" placeholder="Search organisation..." @input="onSearch" @click.stop />
              </div>
              <ul class="user-menu-list org-menu-list">
                <li v-for="org in organisationsList" :key="org.id" :class="{ active: org.id === organisation.id }" @click="onSelectOrg(org)">
                  <i class="fa-solid fa-building me-2"></i> {{ org.name }}
                </li>
              </ul>
            </div>
          </transition>
        </div>

        <!-- User Settings Row -->
        <div class="user-dropdown-container">
          <div class="footer-divider" v-if="!(organisationsList && organisationsList.length > 0)"></div>
          <div class="account-menu-wrapper" @click.stop="toggleUserDropdown">
            <div class="user-info">
              <div class="user-avatar-wrapper">
                <div class="user-avatar">
                  {{ user.icon || userInitials }}
                </div>
                <span class="online-status-dot"></span>
              </div>
              <div class="user-details">
                <div class="user-name">
                  {{ user.first_name }} {{ user.last_name }}
                </div>
                <div class="user-meta-row">
                  <span class="user-role-badge" v-if="userRoleLabel">{{ userRoleLabel }}</span>
                </div>
              </div>
              <div class="footer-actions">
                <span class="footer-chevron" :style="{ transform: `rotate(${chevronRotation}deg)` }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
                <button class="quick-logout-btn" title="Logout"
                  @click.stop="logout()">
                  <i class="fa-solid fa-arrow-right-from-bracket"></i>
                </button>
              </div>
              <!-- Hover tooltip -->
              <div class="user-hover-tooltip">
                <div class="tooltip-name">{{ user.first_name }} {{ user.last_name }}</div>
                <div class="tooltip-role" v-if="userRoleLabel"><i class="fa-solid fa-shield-halved"></i> {{ userRoleLabel }}</div>
              </div>
            </div>
          </div>
          <!-- Dropdown above footer -->
          <transition name="dropdown-slide">
            <div class="user-dropdown" v-if="userDropdownOpen">
              <ul class="user-menu-list">
                <li @click="goToAuthOrgSettings()">
                  <i class="fa-solid fa-building me-2"></i> Organisation Settings
                </li>
                <li @click="goToAuthProfile()">
                  <i class="fa-regular fa-user me-2"></i> User Settings
                </li>
                <li class="logout-item" @click="logout()">
                  <i class="fa-solid fa-arrow-right-from-bracket me-2"></i> Logout
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>

      <div class="toggle-bar">
        <button class="toggle-menu-btn" @click="toggleSidebar">
          <div class="hamburger-icon">
            <svg v-if="!toggleMainSidebar" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </div>
        </button>
      </div>
    </div>



    <div class="sidebar-backdrop" :class="{ active: isBackdropActive }" @click="closeSidebar"></div>

    <div class="modal fade" id="productsList" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static"
      style="top: 2%;">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <div>
              <button ref="closeModalProductsList" type="button" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-title text-center">
              <h4 style="color: #435666;"><strong>Browse to other VERTEX products</strong></h4>
            </div>
            <hr class="mx-2" style="color: #566f83;border-width: 2px;" />
            <ul class="products-wrapper">
              <li v-for="(product, index) in products" :key="index">
                <a class="product-icon" :href="product.link" target="_blank" :title="product.name">
                  <img :src="require('@/assets/img/vertex_products_logo/' + product.logo)" :alt="product.name"
                    class="img-fluid" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { debounce, truncateLongText } from '@/plugins/helper.js'

export default {
  data() {
    return {
      toggleMainSidebar: false,
      isSidebarManuallyToggled: false,
      isBackdropActive: false,

      // Submenu states
      leadsMenuOpen: false,
      clientsMenuOpen: false,
      contentLibraryMenuOpen: false,
      platformSettingsMenuOpen: false,
      platformsDeliveryMenuOpen: false,
      userDropdownOpen: false,
      orgDropdownOpen: false,
      chevronRotation: 0,
      orgChevronRotation: 0,

      // Existing data structure
      user: {
        id: '',
        first_name: '',
        last_name: '',
        icon: '',
      },
      organisationsList: null,
      organisation: {
        id: '',
        uuid: '',
        name: '',
        logo: '',
      },
      search: '',
      debounceFn: null,
      unreadNotifications: 3,
      isDebuggerEnabled: false,
    };
  },

  created() {
    this.init();
    this.debounceFn = debounce(() => this.filterOrganisationsList(), 200);
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
    document.addEventListener("click", this.handleClickOutside);
    this.onResize();

    // Auto-expand menus based on active path
    if (this.$route.path.startsWith("/regression-library") || this.$route.path.startsWith("/quick-links") || this.$route.path.startsWith("/platform-releases")) {
      this.platformsDeliveryMenuOpen = true;
    }
    if (this.$route.path.startsWith("/bdm-details") || this.$route.path.startsWith("/product-pricing") || this.$route.path.startsWith("/maintenance-settings") || this.$route.path.startsWith("/dynamic-variables") || this.$route.path.startsWith("/contract-settings")) {
      this.platformSettingsMenuOpen = true;
    }
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener("click", this.handleClickOutside);
  },

  computed: {
    // Menu Activation States
    isLeadsActive() {
      return this.$route.path.startsWith("/leads") || this.$route.path.startsWith("/proposals") || this.$route.path.startsWith("/contracts");
    },
    isClientsActive() {
      return this.$route.path.startsWith("/clients");
    },
    isContentLibraryActive() {
      return this.$route.path.startsWith("/content-library");
    },
    isPlatformSettingsActive() {
      return this.$route.path.startsWith("/bdm-details") || this.$route.path.startsWith("/product-pricing") || this.$route.path.startsWith("/maintenance-settings") || this.$route.path.startsWith("/dynamic-variables") || this.$route.path.startsWith("/contract-settings");
    },
    isPlatformsDeliveryActive() {
      return this.$route.path.startsWith("/regression-library") || this.$route.path.startsWith("/quick-links") || this.$route.path.startsWith("/platform-releases");
    },
    userInitials() {
      const first = this.user.first_name ? this.user.first_name.charAt(0) : "";
      const last = this.user.last_name ? this.user.last_name.charAt(0) : "";
      return (first + last).toUpperCase();
    },
    userRoleLabel() {
      if (this.$store.state.auth.isConsultant) return 'Consultant';
      if (this.$store.state.auth.isAdmin) return 'Admin';
      if (this.$store.state.auth.isSuperAdmin) return 'Super Admin';
      return '';
    }
  },

  methods: {
    toggleLeadsMenu() {
      this.leadsMenuOpen = !this.leadsMenuOpen;
    },
    toggleClientsMenu() {
      this.clientsMenuOpen = !this.clientsMenuOpen;
    },
    toggleContentLibraryMenu() {
      this.contentLibraryMenuOpen = !this.contentLibraryMenuOpen;
    },
    togglePlatformSettingsMenu() {
      this.platformSettingsMenuOpen = !this.platformSettingsMenuOpen;
    },
    togglePlatformsDeliveryMenu() {
      this.platformsDeliveryMenuOpen = !this.platformsDeliveryMenuOpen;
    },
    toggleUserDropdown() {
      this.userDropdownOpen = !this.userDropdownOpen;
      this.chevronRotation += 180;
    },
    toggleOrgDropdown() {
      this.orgDropdownOpen = !this.orgDropdownOpen;
      this.orgChevronRotation += 180;
    },
    handleClickOutside(event) {
      const userContainer = this.$el.querySelector(".user-dropdown-container");
      const userDropdown = this.$el.querySelector(".user-dropdown");
      if (
        (userContainer && userContainer.contains(event.target)) ||
        (userDropdown && userDropdown.contains(event.target))
      ) {
        // do nothing
      } else {
        this.userDropdownOpen = false;
      }

      const orgContainer = this.$el.querySelector(".org-dropdown-container");
      const orgDropdown = this.$el.querySelector(".org-dropdown-list");
      if (
        (orgContainer && orgContainer.contains(event.target)) ||
        (orgDropdown && orgDropdown.contains(event.target))
      ) {
        // do nothing
      } else {
        this.orgDropdownOpen = false;
      }
    },
    toggleSidebar() {
      this.toggleMainSidebar = !this.toggleMainSidebar;
      this.isSidebarManuallyToggled = true;
      if (window.innerWidth <= 768) {
        this.isBackdropActive = this.toggleMainSidebar;
      }
    },
    closeSidebar() {
      this.toggleMainSidebar = false;
      this.isBackdropActive = false;
    },
    mobileToggleSidebar() {
      if (window.innerWidth < 768) {
        if (this.toggleMainSidebar) {
          this.closeSidebar();
        }
      }
    },
    onResize() {
      if (window.innerWidth > 768) {
        this.isBackdropActive = false;
      }
      if (this.isSidebarManuallyToggled) {
        return;
      }
      if (window.innerWidth < 992) {
        this.toggleMainSidebar = false;
      } else {
        this.toggleMainSidebar = true;
      }
    },

    // Original Methods
    init() {
      this.onResize()
      if (this.$store.state.auth.isAuthenticated) {
        this.user.id = this.$store.state.auth.currentUser.id
        this.user.first_name = this.$store.state.auth.currentUser.first_name
        this.user.last_name = this.$store.state.auth.currentUser.last_name
        this.user.icon = this.retrieveUserIcon(this.$store.state.auth.currentUser.first_name)
        this.getOrganisations()
      }

      // Check if debugger is enabled
      this.$axios.get('/api/debugger/status')
        .then(response => {
          if (response.data && response.data.success) {
            this.isDebuggerEnabled = response.data.is_debug_enabled;
          }
        })
        .catch(err => {
          console.warn("Debugger status endpoint is not available or blocked:", err);
          this.isDebuggerEnabled = false;
        });
    },
    truncateLongText(text, limit) {
      return truncateLongText(text, limit)
    },
    onSearch() {
      this.debounceFn()
    },
    filterOrganisationsList() {
      if (this.search == "") {
        this.organisationsList = this.$store.state.auth.organisationsList
      } else {
        this.organisationsList = this.$store.state.auth.organisationsList.filter((e) => {
          let name = e.name.toLowerCase()
          let searchKeyword = this.search.toLowerCase()
          if (name.includes(searchKeyword)) {
            return e
          }
        })
      }
    },
    onSelectOrg(selectedOrg) {
      this.$store.commit("auth/setCurrentOrganisation", selectedOrg)
      this.organisation.id = this.$store.state.auth.currentOrganisation.id
      this.organisation.name = this.$store.state.auth.currentOrganisation.name
      this.organisation.uuid = this.$store.state.auth.currentOrganisation.orguuid
      this.organisation.logo = this.retrieveOrgLogo(this.$store.state.auth.currentOrganisation)
      this.resetOrganisationsList()
    },
    retrieveOrgLogo(org) {
      return org.name.charAt(0)
    },
    retrieveUserIcon(name) {
      let icon = ""
      if (name != "") icon = name.charAt(0)
      return icon
    },
    resetOrganisationsList() {
      this.search = ""
      this.organisationsList = this.$store.state.auth.organisationsList
    },
    goToAuthProfile() {
      this.userDropdownOpen = false;
      window.open(this.$config.getAuthBaseUrl() + '/user-settings/', '_blank');
    },
    goToAuthOrgSettings() {
      this.userDropdownOpen = false;
      window.open(this.$config.getAuthBaseUrl() + '/organisations/' + this.organisation.id + '/settings/', '_blank');
    },
    logout() {
      this.userDropdownOpen = false;
      this.$axios_auth.post(`/users/${this.user.id}/logout`)
        .then((response) => {
          if (response.data.success) {
            this.$store.dispatch('auth/logout');
            this.$store.commit("auth/setCurrentOrganisation", this.organisation)
          } else {
            this.toast.error(response.data.message)
          }
        })
        .catch(error => {
          this.toast.error(error)
        });
    },
    getOrganisations() {
      if (this.$store.state.auth.isSuperAdmin) {
        this.organisationsList = this.$store.state.auth.organisationsList
        if (this.$route.params.orgId != null) {
          let org = this.organisationsList.filter((o) => {
            if (o.id == this.$route.params.orgId) return o;
          })
          this.$store.commit("auth/setCurrentOrganisation", org[0])
        }
      }
      if (this.$store.state.auth.currentOrganisation && this.$store.state.auth.currentOrganisation.id) {
        this.organisation.id = this.$store.state.auth.currentOrganisation.id
        this.organisation.name = this.$store.state.auth.currentOrganisation.name
        this.organisation.uuid = this.$store.state.auth.currentOrganisation.orguuid
        this.organisation.logo = this.retrieveOrgLogo(this.$store.state.auth.currentOrganisation)
      } else if (this.$store.state.auth.currentUser && this.$store.state.auth.currentUser.organisation) {
        const userOrg = this.$store.state.auth.currentUser.organisation
        this.organisation.id = userOrg.id
        this.organisation.name = userOrg.name
        this.organisation.uuid = userOrg.orguuid
        this.organisation.logo = this.retrieveOrgLogo(userOrg)
        this.$store.commit("auth/setCurrentOrganisation", userOrg)
      }
    }
  },
  watch: {
    toggleMainSidebar(newVal) {
      this.$emit("sidebar-toggled", newVal);
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.main-sidebar-container {
  background: #435666;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 70px;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.main-sidebar-container.expanded {
  width: 260px;
}

.sidebar {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Logo Section */
.logo-section {
  padding: 20px;
  border-bottom: 1px solid rgba(163, 192, 209, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.logo-img {
  width: 32px;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
}

/* Navigation Menu */
.nav-menu-wrapper {
  flex: 1;
  padding: 20px 0;
  overflow-y: auto;
}

.nav-menu-list {
  list-style: none;
  padding: 0 10px;
}

.nav-menu-item {
  margin-bottom: 4px;
}

.nav-menu-link,
.submenu-link {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  color: #a3c0d1;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.nav-menu-link:hover,
.submenu-link:hover {
  background-color: rgba(163, 192, 209, 0.1);
  color: #fff;
  transform: translateX(2px);
}

/* 1. Standalone main links and active child links get the solid gradient */
.nav-menu-link.active:not(.submenu-toggle),
.submenu-link.active {
  background: linear-gradient(135deg, #00a0c1, #0088a3);
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 160, 193, 0.3);
}

.menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.menu-icon i {
  font-size: 1.2rem;
  color: inherit;
}

.menu-label {
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
  white-space: nowrap;
}

.main-sidebar-container.expanded .menu-label {
  opacity: 1;
  transform: translateX(0);
}

.menu-beta-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 8.5px;
  font-weight: 800;
  letter-spacing: 0.5px;
  background-color: #00a0c1;
  color: #ffffff;
  padding: 1px 4px;
  border-radius: 4px;
  margin-left: 6px;
  line-height: 1.1;
  text-transform: uppercase;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
  flex-shrink: 0;
  position: relative;
  top: -6px;
}

.main-sidebar-container.expanded .menu-beta-tag {
  opacity: 1;
  transform: translateX(0);
}

.submenu-link.active .menu-beta-tag,
.nav-menu-link.active .menu-beta-tag {
  background-color: #ffffff;
  color: #00a0c1;
}

/* --- SUBMENU STYLES & THE GAP FIX --- */
.submenu {
  list-style: none;
  padding-left: 20px;
  margin-top: 4px;
  /* <--- FIXES THE GAP BETWEEN PARENT & FIRST CHILD */
}

.main-sidebar-container:not(.expanded) .submenu {
  padding-left: 0;
}

.submenu-item {
  margin-bottom: 4px;
}

/* --- SMOOTH TOGGLE ANIMATION --- */
.submenu-slide-enter-active,
.submenu-slide-leave-active {
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-top 0.3s ease-in-out;
  max-height: 500px;
  /* Arbitrary large number to fit all children */
  overflow: hidden;
}

.submenu-slide-enter-from,
.submenu-slide-leave-to {
  max-height: 0;
  opacity: 0;
  margin-top: 0;
  /* Shrinks the gap so it doesn't linger when closing */
}

.nav-menu-link-container {
  position: relative;
}

.nav-menu-link.submenu-toggle {
  padding-right: 40px; 
}

.submenu-arrow {
  position: absolute;
  right: 15px; /* Increased from 10px for more space */
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: #a3c0d1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none; /* Ensures clicking the arrow still triggers the container click */
}

.submenu-arrow svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center center;
}

.submenu-arrow.rotated svg {
  transform: rotate(180deg);
}

/* --- COLLAPSED STATE FIXES --- */

/* 1. Completely hide the label, beta tag and arrow so they don't push the icon off-screen */
.main-sidebar-container:not(.expanded) .menu-label,
.main-sidebar-container:not(.expanded) .menu-beta-tag
{
  display: none;
}

/* Position and resize the arrow specifically for the 70px collapsed sidebar */
.main-sidebar-container:not(.expanded) .submenu-arrow {
  display: flex;
  right: 4px; /* Push it to the far right edge */
}

.main-sidebar-container:not(.expanded) .submenu-arrow svg {
  width: 14px; /* Make the arrow slightly smaller so it fits cleanly */
  height: 14px;
}

/* Offset the icon slightly to the left so it doesn't collide with the arrow */
.main-sidebar-container:not(.expanded) .nav-menu-link.submenu-toggle {
  padding-right: 24px; 
}

/* 2. Perfectly center BOTH parent links and child links */
.main-sidebar-container:not(.expanded) .nav-menu-link,
.main-sidebar-container:not(.expanded) .submenu-link {
  justify-content: center;
  padding: 12px 0;
  /* Remove side padding to allow true centering */
}

/* 3. Strip any leftover margins from the icon */
.main-sidebar-container:not(.expanded) .menu-icon {
  margin: 0;
}

/* Toggle Button */
.toggle-bar {
  position: absolute;
  right: -18px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1001;
}

.toggle-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #00a0c1, #0088a3);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 160, 193, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
}

.toggle-menu-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 160, 193, 0.4);
}

.toggle-menu-btn:active {
  transform: scale(0.95);
}

.hamburger-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hamburger-icon svg {
  width: 20px;
  height: 20px;
  color: white;
}

/* ===== FOOTER DIVIDER ===== */
.footer-divider {
  height: 1px;
  margin: 0 14px 6px;
  background: linear-gradient(90deg, transparent, rgba(163, 192, 209, 0.25), transparent);
}

/* ===== ACCOUNT SECTION ===== */
.account-menu-wrapper {
  padding: 8px 10px;
  transition: padding 0.3s ease;
}

.main-sidebar-container:not(.expanded) .account-menu-wrapper {
  padding: 8px 0;
}

.user-info {
  display: flex;
  align-items: center;
  padding: 10px 10px;
  color: #a3c0d1;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease;
  position: relative;
}

.user-info:hover {
  background-color: rgba(163, 192, 209, 0.1);
}

/* Avatar wrapper for status dot */
.user-avatar-wrapper {
  position: relative;
  flex-shrink: 0;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00a0c1, #0088a3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.15);
  transition: border-color 0.2s ease;
}

.user-info:hover .user-avatar {
  border-color: rgba(255, 255, 255, 0.35);
}

/* Online status green dot */
.online-status-dot {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background: #22c55e;
  border-radius: 50%;
  border: 2px solid #435666;
  box-shadow: 0 0 4px rgba(34, 197, 94, 0.5);
}

/* Hover tooltip */
.user-hover-tooltip {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 10px;
  right: 10px;
  background: #2e3d4a;
  border-radius: 10px;
  padding: 12px 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(163, 192, 209, 0.08);
  opacity: 0;
  transform: translateY(6px);
  pointer-events: none;
  transition: all 0.2s ease;
  z-index: 10;
}

.user-hover-tooltip::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 24px;
  width: 10px;
  height: 10px;
  background: #2e3d4a;
  transform: rotate(45deg);
  border-radius: 0 0 2px 0;
}

.user-info:hover .user-hover-tooltip {
  opacity: 1;
  transform: translateY(0);
}

.tooltip-name {
  font-size: 13px;
  font-weight: 600;
  color: #e2ecf2;
  margin-bottom: 6px;
}

.tooltip-org,
.tooltip-role {
  font-size: 11px;
  color: #7b97a8;
  line-height: 1.6;
}

.tooltip-org i,
.tooltip-role i {
  width: 14px;
  font-size: 10px;
  color: #5a7a8e;
  margin-right: 4px;
}

.tooltip-role {
  color: #5cc8dc;
}

/* User details block (name + org) */
.user-details {
  margin-left: 10px;
  min-width: 0;
  flex: 1;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
}

.main-sidebar-container.expanded .user-details {
  opacity: 1;
  transform: translateX(0);
}

.user-name {
  font-size: 13px;
  font-weight: 600;
  color: #e2ecf2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

/* Meta row (org name + role badge side by side) */
.user-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 1px;
}

.user-org-name {
  font-size: 11px;
  font-weight: 400;
  color: #7b97a8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

/* Role badge pill (sits next to org name) */
.user-role-badge {
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 20px;
  background: rgba(0, 160, 193, 0.18);
  color: #5cc8dc;
  white-space: nowrap;
  line-height: 1.5;
  flex-shrink: 0;
}

/* Footer actions (chevron + logout only) */
.footer-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.main-sidebar-container.expanded .footer-actions {
  opacity: 1;
}

/* Chevron affordance */
.footer-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7b97a8;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s ease;
}

.user-info:hover .footer-chevron {
  color: #a3c0d1;
}

/* Quick logout button (inline icon) */
.quick-logout-btn {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #7b97a8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.quick-logout-btn:hover {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

/* Hide user-details, footer-actions, tooltip and quick logout in collapsed state */
.main-sidebar-container:not(.expanded) .user-details,
.main-sidebar-container:not(.expanded) .footer-actions,
.main-sidebar-container:not(.expanded) .user-hover-tooltip {
  display: none;
}

.main-sidebar-container:not(.expanded) .quick-logout-btn {
  display: none;
}

.main-sidebar-container:not(.expanded) .footer-divider {
  margin: 0 8px 6px;
}

/* Center avatar in collapsed mode */
.main-sidebar-container:not(.expanded) .user-info {
  justify-content: center;
  padding: 10px 0;
}

/* ===== USER DROPDOWN ===== */
.user-dropdown-container {
  position: relative;
}

.user-dropdown {
  position: absolute;
  bottom: 100%;
  left: 8px;
  right: 8px;
  margin-bottom: 4px;
  background: #2e3d4a;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(163, 192, 209, 0.08);
  z-index: 1002;
  overflow: hidden;
}

/* Dropdown slide animation */
.dropdown-slide-enter-active,
.dropdown-slide-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-slide-enter-from,
.dropdown-slide-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(0.97);
}


.user-menu-list {
  list-style: none;
  padding: 6px 0;
  margin: 0;
}

.user-menu-list li {
  padding: 11px 18px;
  color: #a3c0d1;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
}

.user-menu-list li:hover {
  background-color: rgba(163, 192, 209, 0.08);
  color: #fff;
}

.user-menu-list li.logout-item {
  color: #ef7070;
}

.user-menu-list li.logout-item:hover {
  background-color: rgba(239, 68, 68, 0.1);
  color: #f87171;
}

/* Backdrop for mobile */
.sidebar-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.sidebar-backdrop.active {
  opacity: 1;
  visibility: visible;
}

/* Responsive design */
@media (max-width: 768px) {
  .main-sidebar-container {
    transform: translateX(-100%);
    width: 260px;
    box-shadow: none;
  }

  .main-sidebar-container.expanded {
    transform: translateX(0);
    box-shadow: 10px 0 30px rgba(0, 0, 0, 0.3);
  }

  .toggle-bar {
    position: fixed;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1002;
  }

  .main-sidebar-container.expanded .toggle-bar {
    right: 20px;
    left: auto;
  }

  .logo-text,
  .menu-label,
  .user-name,
  .user-details,
  .footer-actions {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Products Modal Styles */
.products-wrapper {
  list-style: none;
  padding: 0px 0px;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  font-size: 13px;
}

.products-wrapper li {
  position: relative;
  display: inline-block;
  padding: 0.5rem;
  margin: 0.5rem;
  width: calc(100%/2.2);
  text-align: center;
}

.products-wrapper .product-icon img {
  cursor: pointer;
}

.notification-container {
  position: relative;
}

.notification-button {
  background: none;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 24px;
  padding: 0;
  margin: 0;
}

.notification-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4d4f;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
}

/* ===== ORGANISATION SWITCHER STYLES ===== */
.org-dropdown-container {
  position: relative;
}

.org-avatar {
  background: linear-gradient(135deg, #f59e0b, #fbbf24) !important;
}

.org-avatar i {
  font-size: 14px;
  color: white;
}

.org-name-text {
  color: #e2ecf2 !important;
  font-weight: 700 !important;
}

.org-badge {
  background: rgba(245, 158, 11, 0.18) !important;
  color: #fbbf24 !important;
}

.org-dropdown-list {
  background: #2e3d4a;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(163, 192, 209, 0.08);
}

.org-menu-list li {
  padding: 10px 16px;
  font-size: 13px;
  color: #a3c0d1;
  transition: all 0.2s;
}

.org-menu-list li:hover, .org-menu-list li.active {
  background-color: rgba(245, 158, 11, 0.15) !important;
  color: #fff !important;
}

.org-search-box input {
  background-color: #1e293b;
  border: 1px solid #475569;
  color: #fff;
  border-radius: 6px;
}

.org-search-box input:focus {
  background-color: #0f172a;
  border-color: #fbbf24;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}

/* Collapse adjustments */
.main-sidebar-container:not(.expanded) .org-dropdown-container .user-info {
  justify-content: center;
  padding: 10px 0;
}

.main-sidebar-container:not(.expanded) .org-dropdown-container .org-avatar-wrapper {
  margin: 0;
}

.main-sidebar-container:not(.expanded) .org-dropdown-container .org-details,
.main-sidebar-container:not(.expanded) .org-dropdown-container .org-footer-actions,
.main-sidebar-container:not(.expanded) .org-dropdown-container .org-hover-tooltip {
  display: none;
}
</style>